import type { GbaRam } from '../gba-ram';
import { activeSymbols, type FireRedSymbols } from './symbols';

// struct Pokemon (100 bytes) = BoxPokemon (80) + dados de batalha; o 1º da equipe é o líder. Na BoxPokemon, os 48 bytes
// a partir de 0x20 são 4 blocos de 12 (Growth, Attacks, EVs, Misc) em uma das 24 ordens
// (personality % 24) e criptografados com XOR de (personality ^ otId) — include/pokemon.h.
const BOX_PERSONALITY = 0x00;
const BOX_OT_ID = 0x04;
const BOX_FLAGS = 0x13; // bit 0 isBadEgg, bit 1 hasSpecies, bit 2 isEgg
const BOX_SECURE = 0x20;
const SUBSTRUCT_SIZE = 12;
const ORDERS = [
  'GAEM', 'GAME', 'GEAM', 'GEMA', 'GMAE', 'GMEA', 'AGEM', 'AGME', 'AEGM', 'AEMG', 'AMGE', 'AMEG',
  'EGAM', 'EGMA', 'EAGM', 'EAMG', 'EMGA', 'EMAG', 'MGAE', 'MGEA', 'MAGE', 'MAEG', 'MEGA', 'MEAG',
];

export interface PartyLead {
  /** Espécie (número interno do jogo; 0 = nenhum). */
  species: number;
  isEgg: boolean;
}

/** Primeiro Pokémon da equipe (o que segue o jogador), ou null se a equipe está vazia. */
export function readPartyLead(ram: GbaRam, sym: FireRedSymbols = activeSymbols()): PartyLead | null {
  const count = ram.u8at(sym.gPlayerPartyCount);
  if (count === 0 || count > 6) return null;
  const mon = sym.gPlayerParty; // 1º da equipe
  const flags = ram.u8at(mon + BOX_FLAGS);
  if ((flags & 0b11) !== 0b10) return null; // sem espécie ou "ovo ruim"
  const personality = ram.u32(mon + BOX_PERSONALITY);
  const key = (personality ^ ram.u32(mon + BOX_OT_ID)) >>> 0;
  const growth = ORDERS[personality % 24].indexOf('G');
  const firstWord = (ram.u32(mon + BOX_SECURE + growth * SUBSTRUCT_SIZE) ^ key) >>> 0;
  const species = firstWord & 0xffff;
  if (species === 0 || species >= 440) return null;
  return { species, isEgg: (flags & 0b100) !== 0 };
}

